import { Translation } from "@eco/client";

/**
 * Map to store translations 
 * 
 */
export class TranslationMap {

    // use inner Map vs extends Map> We cannot extend Map: 
    // TS Map to JS es5 conversion fails @runtime. 
    private innerMap: Map<string,string> ;

    private loaded = false ;

    /**
     * 
     * @param translations array of translations {key, value} objects
     * 
     */
    constructor(translations:Translation[]){
        this.innerMap = new Map(translations.map( entry => [entry.key, entry.value])) ;
    }

    /**
     * 
     * Get tranlation by key
     * 
     * @param key translation key
     * @param params optionnal set of dynamic parameters
     * @returns tranlated text
     * 
    
    public get(key: string, ...parms: Array<string>) : string
     */
    /**
     * 
     * Get translation by array of keys
     * Will return an array of value in the same order as keys
     * 
     * @param keys Array of translation key
     
    public get(keys: Array<string>) : Array<string>
    */
    
    public get(key: string | Array<string>, ...params: string[] ) : Array<string>   {

        if (typeof key === 'string') {
            return [this.getKey(key, params)]
        }
    
        return key.map((item) => this.getKey(item))
    }

    private getKey(key: string, params?: string[]): string {
        let value: string | undefined = this.innerMap.get(key);
        if(!value){
            return key;
        }

        if(params && params.length){
            params.forEach( (param, index) => {
                value = value!.replace(new RegExp(`\\$${index + 1}`, 'g'), param );
            });
        }

        return value;
    }

    public getInnerMap(): Array<{ key: string, value: string }>{
        const result: Array<{ key: string, value: string }> = []
        this.innerMap.forEach((value, key) => {
            result.push({ key, value })
        })
        return result
    }

    setLoaded() : void{
        this.loaded = true ;
    }
    
    isLoaded() : boolean {
        return this.loaded;
    }

    isEmpty() : boolean{
        return this.innerMap.size === 0 ;
    }

}
